import { humanizeEnum } from './run-status';

/** Flow code → the name an operator would use for that step (one name per step, app-wide). */
const FLOW_LABELS: Record<string, string> = {
  PRODUCT_TYPE_DETECTION: 'Product group detection',
  CORE_ATTRIBUTION: 'Attribute extraction',
  SEARCH_DESCRIPTORS: 'Search terms',
  PHRASE_DESCRIPTORS: 'Descriptive phrases',
  CONTENT_ENRICHMENT: 'Writing',
  CONTENT_DETERMINISTIC_SCORING: 'Scoring (rules)',
  CONTENT_LLM_SCORING: 'Scoring (AI)',
  CONTENT_GAP_ANALYSIS: 'Gap check',
};

/** Short forms of the same names, for chips, tabs and table headers where space is tight. */
const FLOW_SHORT_LABELS: Record<string, string> = {
  PRODUCT_TYPE_DETECTION: 'Detection',
  CORE_ATTRIBUTION: 'Attributes',
};

/**
 * The option that runs Product group detection and Attribute extraction again even where saved
 * results exist (`forceExtract`) — one label on every Set up page and dialog.
 */
export const REDO_UNDERSTANDING_LABEL = `Redo ${FLOW_LABELS.PRODUCT_TYPE_DETECTION?.toLowerCase() ?? 'product group detection'} & ${FLOW_LABELS.CORE_ATTRIBUTION?.toLowerCase() ?? 'attribute extraction'}`;

/** The one readable name for a flow, used on every Content page; unknown codes fall back to sentence case. */
export function flowLabel(flow: string): string {
  return FLOW_LABELS[flow] ?? humanizeEnum(flow);
}

/** The short name for a flow ("Detection", "Attributes"); the full name when it has no short form. */
export function flowShortLabel(flow: string): string {
  return FLOW_SHORT_LABELS[flow] ?? flowLabel(flow);
}
